
      import Happy from './happy.vue'
      import type { App, Plugin } from 'vue'

      export const HappyPlugin: Plugin = {
        install(app: App) {
          app.component('Happy', Happy)
        },
      }
      export { Happy }
      